<div class="block-head">
  <h3>{{ "products.tab-documents"| translate }}</h3>
</div>
<ng-container *ngIf="fundManagers?.length > 0">
  <h4 class="mb-0 px-36">{{ "products.overview-fund-managers" | translate }}</h4>

  <div class="bg-gradient managers">

    <div class="manager-slider">
      <ngx-slick-carousel [ngStyle]="{'padding-left': isMobileView ? '0px' : '10px'}" style="padding-right: 10px;"
                          class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem class="slide" *ngFor="let data of fundManagers;let i = index">
          <div class="manager-block">
            <img alt="{{data.name}}" [src]="getImageForCoursel(data.name)">
            <div>
              <div class="text-big addFontSize1">{{ data.name }}</div>
              <div class="removeFontSize1">{{ "products.managing-this-fund-since" | translate }} {{ data.startDate }}
              </div>
              <a (click)="viewManagerFunds(data)" class="d-none d-md-block fundManagerFontSize1" data-bs-toggle="modal"
                 data-bs-target="#managed-fund-modal"
                 href="#">
                {{ "products.view-all-managed-funds" | translate }}
                <i class="bi bi-arrow-right"></i>
              </a>
              <a (click)="viewManagerFunds(data)" class="d-md-none" data-bs-toggle="offcanvas"
                 data-bs-target="#offcanvasBottomFM"
                 aria-controls="offcanvasBottom" href="#">
                {{ "products.view-all-managed-funds" | translate }}
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</ng-container>

<div class="block-body">
  <div class="row scheme-details">
    <div class="col-md-6 col-12" [ngClass]="{'col-md-12 col-12' : !showFinacial}">
      <h4 class="small-title">{{ "products.scheme-details-title" | translate }}</h4>
      <div class="padding-box">
        <div class="table-responsive table-bordered" tabindex="0">
          <table class="table  table-striped">
            <tbody>
            <tr *ngIf="overview?.inceptionDate">
              <td><span>{{ "products.overview-inception-date" | translate }}</span></td>
              <td>{{ overview?.inceptionDate }}</td>
            </tr>
            <tr>
              <td>{{ "products.overview-benchmarks" | translate }}</td>
              <td class="small-cell">
                <span *ngFor="let benchmark of additionalInfo?.benchmarks">{{ benchmark }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ "products.overview-entry-load" | translate }}</td>
              <td class="small-cell">{{ fundDocument?.entryload | ftDashIfEmpty }}</td>
            </tr>
            <tr>
              <td>{{ "products.overview-exit-load" | translate }}</td>
              <td class="small-cell">
                <span [innerHtml]="fundDocument?.exitload | ftDashIfEmpty"></span>
              </td>
            </tr>
            <tr>
              <td>{{ "products.aum-month-end" | translate }}</td>
              <td class="small-cell" *ngIf=" additionalInfo?.fundSize && additionalInfo?.fundSize !=='' else blank">
                {{ additionalInfo?.fundSize }} {{ "products.compare-crores" | translate }}
              </td>
              <ng-template #blank>
                <td class="small-cell"> -</td>
              </ng-template>
            </tr>
            <!-- <tr> IDM-508
               <td>AUM(Monthly average)</td>
               <td class="small-cell"> -</td>
             </tr>-->
            <tr>
              <td>{{ "products.fund-header-minimum-investment" | translate }}</td>
              <td class="small-cell">{{ minimalInvestment }}</td>
            </tr>
            <!--<tr>
              <td>Minimum Investment for SIP</td>
              <td class="small-cell">500/1</td>
            </tr>-->
            <tr>
              <td>{{ "products.fund-header-additional-investment" | translate }}</td>
              <td class="small-cell">{{ additionalInvestment }}</td>
            </tr>
            <!--<tr>
              <td>Lock in Period</td>
              <td class="small-cell">3 Years</td>
            </tr>-->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12" *ngIf="showFinacial">
      <h4 class="small-title">{{ "products.financial-ratio-title" | translate }}</h4>
      <div class="padding-box">
        <div class="table-responsive table-bordered" tabindex="0">
          <table class="table table-striped">
            <tbody>
            <tr *ngIf="additionalInfo?.standardDeviation">
              <td><span [innerHTML]="'products.overview-standard-deviation' | translate">
              </span></td>
              <td>{{ additionalInfo?.standardDeviation }}%</td>
            </tr>
            <tr *ngIf="additionalInfo?.beta">
              <td><span [innerHTML]="'products.overview-beta' | translate"></span></td>
              <td>{{ additionalInfo?.beta }}</td>
            </tr>
            <tr *ngIf="additionalInfo?.sharpeRatio">
              <td><span [innerHTML]="'products.overview-sharpe-ratio' | translate"></span></td>
              <td>{{ additionalInfo?.sharpeRatio }}</td>
            </tr>
            <tr *ngIf="additionalInfo?.rSquaredRatio">
              <td><span [innerHTML]="'products.overview-r-squared-ratio' | translate">
              </span></td>
              <td>{{ additionalInfo?.rSquaredRatio }}</td>
            </tr>
            <tr *ngIf="additionalInfo?.riskFreeRate">
              <td><span [innerHTML]="'products.overview-risk-free-rate' | translate">
              </span></td>
              <td>{{ additionalInfo?.riskFreeRate }}%</td>
            </tr>
            <tr *ngIf="additionalInfo?.portfolioTurnover">
              <td><span [innerHTML]="'products.overview-portfolio-turnover' | translate">
              </span></td>
              <td>{{ additionalInfo?.portfolioTurnover }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="block-body te-td-error" *ngIf="showTE || showTD">
  <div class="row gx-0 daily-nav-table">
    <div class="col-md-6 col-12" *ngIf="showTE">
      <h4 class="small-title">{{ "products.tracking-error-title" | translate }}&nbsp;{{ TEAsofDate }}</h4>
      <div class="padding-box te-td-wd-99">
        <div class="table-responsive">
          <table class="table table-success table-striped">
            <thead>

            </thead>
            <tbody>
            <tr *ngFor="let shareClassObj of TEData">
              <td style="background: none;">{{ replaceNSEwithRegular(shareClassObj.name) }}</td>
              <td style="background: none;">{{ shareClassObj.te1year }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="te-caveat-class" [innerHTML]="'products.tracking-error-caveat' | translate"></div>
      </div>
    </div>
    <div class="col-md-6 col-12" *ngIf="showTD">
      <h4 class="small-title">{{ "products.tracking-difference-title" | translate }}&nbsp;{{ TDAsofDate }}
      </h4>
      <div class="padding-box">
        <div class="table-responsive mb-10">
          <table class="table table-success table-striped">
            <thead>
            <tr>
              <th scope="col" *ngFor="let name of shareClassArr">
                {{ replaceNSEwithRegular(name) }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let rowArr of TDData">
              <td *ngFor="let ele of rowArr">
                {{ ele }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="td-caveat-class" [innerHTML]="'products.tracking-difference-caveat' | translate"></div>
      </div>
    </div>
  </div>
</div>
<div class="block-body te-td-border" *ngIf="showLaunchData">
  <div class="padding-box" style="padding-top: 0;">
    <div class="row gx-0 daily-nav-table">
      <div class="col-md-12 col-12">
        <div class="table-responsive">
          <table class="table table-success table-striped">
            <thead>
            <tr>
              <th scope="col">{{ "products.tracking-error-scheme-name" | translate }}</th>
              <th scope="col">{{ "products.tracking-error-launch-date" | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let shareClassObj of LaunchData">
              <td>{{ shareClassObj.name }}</td>
              <td>{{ shareClassObj.date }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="managed-fund-modal" style="z-index: 100000;" tabindex="-1" aria-labelledby="callBackLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-height: 800px;">
    <div class="modal-content" style=" width: 85%; margin: auto;">
      <div class="modal-header" style="position: sticky; top: 0;">
        <div class="modal-title" id="callBackLabel">{{ "products.managed-funds-by" | translate }}<span
            style="color: #3769ff;"> {{ fundManagerName }}
        </span></div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="max-height: 440px; overflow-y: auto;">
        <ng-container *ngIf="fundsList.length > 0 else elseBlock">
          <div class="fund-block position-relative mt-1 mb-4" *ngFor="let data of fundsList"
               style="border: 1px solid #D2D8EA;padding:20px;">
            <!-- <span style="margin-top: 5px;" class="recommend-tag">Recommended</span> -->
            <div class="d-flex justify-content-between fund-head" style="margin-top: 5px;">
              <div class="d-flex justify-content-between d-none d-md-flex">
                <div style="max-width: 269px;width:270px;">
                  <h5 class="mb-0">
                    <a>
                      <span>{{ data.fundName }}</span>
                    </a>
                  </h5>
                </div>
                <div>
                  <span class="img-with-tooltip">
                    <img alt="image" src="assets/images/general/very-high.webp">
                    <span class="tooltip-block">
                      <img alt="image" src="assets/images/general/very-high.webp">
                      {{ getRisk(data?.contentData.productLabel) }}
                    </span>
                  </span>
                </div>
                <div class="tags" style="margin-bottom: auto; margin-left: 19px;">
                  <ul>
                    <!-- *ngFor="let tag of data?.tag" -->
                    <li style="white-space: nowrap;">{{ removeFundString(data?.assetClass) }}</li>
                    <li style="white-space: nowrap;">{{ removeFundString(data?.invfocus) }}</li>
                    <li style="white-space: nowrap;">{{ data?.fundAge }} Years Old Fund</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row info justify-content-between">
              <ul class="col-auto  d-none d-md-block">
                <li>
                  <div class="mb-2">{{ "products.fundCompareInvestors" | translate }}
                    <span class="img-with-tooltip" *ngIf="data?.contentData?.uniqueInvestors !== ''">
                      <img alt="image" src="assets/images/home/info-icon2.svg">
                      <span class="tooltip-block" style="left: -95px;">
                        {{ "products.as-of-capitalize" | translate }}&nbsp;{{ getEndOfLastQuarter() }}
                      </span>
                    </span>
                  </div>
                  <div class="text-big">
                    <span class="d-inline-block d-md-none"><img alt="image" src="assets/images/fund/investor-icon.svg"></span>
                    {{ (Number((data.contentData.uniqueInvestors).replace(',', '')) | INRCurrencyNumberInt) }}
                    <span class="d-inline-block d-md-none">{{ "products.fundCompareInvestors" | translate }}</span>
                  </div>
                </li>
                <li>
                  <div class="mb-2">{{ "products.aum" | translate }}
                    <span class="img-with-tooltip" *ngIf="data.aumData?.totalNetAssets !== null">
                      <img alt="image" src="assets/images/home/info-icon2.svg">
                      <span class="tooltip-block">
                        {{ "products.as-of-capitalize" | translate }}&nbsp;{{ data?.aumData?.asOfDate }}
                      </span>
                    </span>
                  </div>
                  <div class="text-big">
                    <span class="d-inline-block d-md-none"><img alt="image"
                                                                src="assets/images/fund/money-sign.svg"></span>
                    {{
                          data?.aumData?.totalNetAssets !== null && data?.aumData?.totalNetAssets !== undefined ? (data?.aumData?.totalNetAssets |INRCurrencyNumber) + ' Cr' : '-'
                    }}
                    <span class="d-inline-block d-md-none">{{ "products.aum" | translate }}</span>
                  </div>
                </li>
                <li class="last-item">
                  <div class="mb-2"
                       style="vertical-align: super;">{{ "products.funds-home-card-annualized-returns" | translate }}
                    <span class="img-with-tooltip" *ngIf="data?.selectedDropdown?.assetValue">
                      <img alt="image" src="assets/images/home/info-icon2.svg">
                      <span class="tooltip-block">
                        {{ "products.as-of-capitalize" | translate }}&nbsp;{{ data?.performanceData?.asOfDate }}
                      </span>
                    </span>
                  </div>
                  <div *ngIf="data?.selectedDropdown?.assetValue else perfElse">
                    <span
                        class="text-big">{{ data?.selectedDropdown?.assetValue ? data?.selectedDropdown?.assetValue + '%' : 'NA' }}</span>
                    <div class="dropdown d-none d-md-inline-block">
                      <button class="btn btn-white dropdown-toggle" type="button" id="dropdownMenuButton1"
                              data-bs-toggle="dropdown" aria-expanded="false">
                        {{ data?.selectedDropdown?.label }}
                      </button>
                      <ul class="dropdown-menu cust-dd" aria-labelledby="dropdownMenuButton1">
                        <li *ngFor="let dropdown of data?.performancePeriodDropdownItems"
                            [class.disabled]="dropdown?.disabled">
                          <a class="dropdown-item cursor-pointer" [class]="dropdown?.disabled?'disabled':'cur-pointer'"
                             (click)="updateSelectedDropdown(dropdown,data.fundId)">{{ dropdown?.label }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ng-template #perfElse>
                    <span class="text-big">NA</span>
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-template #elseBlock>
          <div class="text-center mb-5 mt-5">
            <div id="loader">
              <img src="assets/images/home/loader.gif" alt="Loading...">
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- offcanvas -->
<div class="offcanvas offcanvas-bottom for-add-offcanvas-bottom" tabindex="-1" id="offcanvasBottomFM"
     aria-labelledby="offcanvasBottomLabel"
     style="height: 70%; border-top-left-radius: 39px; border-top-right-radius: 39px;">
  <div class="offcanvas-header">
    <span class="line"></span>
  </div>
  <div class="container d-flex flex-row" style="align-items: baseline;gap: 8px;">
    <h5 class="offcanvas-title" style="font-size:1.1rem;">{{ "products.managed-funds-by" | translate }} </h5> <span
      style="color: #3769ff;font-size:1.15rem;">{{ fundManagerName }}</span>
  </div>
  <!-- <button type="button" class="btn-close text-reset" (click)="closeModal()" aria-label="Close"></button> -->
  <div class="offcanvas-body small" style="max-height: 540px; overflow-y: auto;">
    <ng-container *ngIf="fundsList.length > 0 else elseBlock">
      <div class="fund-block position-relative mt-2 mb-3" *ngFor="let data of fundsList"
           style="border: 1px solid #D2D8EA;justify-content: flex-start;min-height:auto;height:auto;">
        <span style="margin-top: 5px;" *ngIf="data?.badge" class="recommend-tag">{{ data?.badge }}</span>
        <div class="d-flex justify-content-between fund-head" style="margin-top: 5px;margin-bottom:5px;">
          <div class="d-flex d-md-none" style="flex-wrap:wrap;">
            <div style="max-width: 243px;width:232px;">
              <h3 class="mb-0">
                <a>
                  <span>{{ data.fundName }}</span>
                </a>
              </h3>
            </div>
            <div>
              <span class="img-with-tooltip">
                <img alt="image" src="assets/images/general/very-high.webp">
                <span class="tooltip-block">
                  <img alt="image" src="assets/images/general/very-high.webp">
                  {{ getRisk(data?.contentData.productLabel) }}
                </span>
              </span>
            </div>
            <div class="tags mt-0" style="margin-bottom: auto;margin-top:10px!important;">
              <ul>
                <li style="white-space: nowrap;">{{ removeFundString(data?.assetClass) }}</li>
                <li style="white-space: nowrap;">{{ removeFundString(data?.invfocus) }}</li>
                <li style="white-space: nowrap;">{{ data?.fundAge }} Years Old Fund</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row info justify-content-between">
          <ul class="col-auto d-md-none">
            <li class="d-flex w-100 justify-content-between">
              <div class="mb-2">{{ "products.fundCompareInvestors" | translate }}
                <span class="img-with-tooltip">
                  <img alt="image" src="assets/images/home/info-icon2.svg">
                  <span class="tooltip-block">
                    {{ "products.as-of-capitalize" | translate }}&nbsp;{{ getEndOfLastQuarter() }}
                  </span>
                </span>
              </div>
              <div class="text-small" *ngIf="data?.contentData?.uniqueInvestors !== ''">
                <span class="d-inline-block d-md-none"><img alt="Investors"
                    src="assets/images/fund/investor-icon.svg"></span>
                {{ (Number((data.contentData.uniqueInvestors).replace(',', '')) | INRCurrencyNumberInt) }}
                {{ "products.fundCompareInvestors" | translate }}
                <span class="img-with-tooltip">
                  <img alt="image" src="assets/images/home/info-icon2.svg">
                  <span class="tooltip-block" style="left: -95px;">
                    {{ "products.as-of-capitalize" | translate }}&nbsp;{{ getEndOfLastQuarter() }}
                  </span>
                </span>
              </div>
              <!-- <div class="mb-2">AUM </div> -->
              <div class="text-small" *ngIf="data.aumData?.totalNetAssets !== null">
                <span class="d-inline-block d-md-none"><img alt="image" src="assets/images/fund/money-sign.svg"></span>
                {{
                      data?.aumData?.totalNetAssets !== null && data?.aumData?.totalNetAssets !== undefined ?
                          (data?.aumData?.totalNetAssets |INRCurrencyNumber) + ' Cr' : '-'
                }}
                <span>{{ "products.aum" | translate }}
                  <span class="img-with-tooltip" *ngIf="data.aumData?.totalNetAssets !== null">
                    <img alt="image" src="assets/images/home/info-icon2.svg">
                    <span class="tooltip-block">
                      {{ "products.as-of-capitalize" | translate }}&nbsp;{{ data?.aumData?.asOfDate }}
                    </span>
                  </span>
                </span>
              </div>
            </li>
            <li class="last-item d-flex justify-content-between" style="border-top:0;margin-top:10px;">
              <div class="d-flex" style="gap:10px;">{{ "products.funds-home-card-annualized-returns" | translate }}
                <span class="img-with-tooltip">
                  <img alt="image" src="assets/images/home/info-icon2.svg">
                  <!-- <img alt="image" src="assets/images/fund/dark-information-icon.png" class="dark-mode-icon"> -->
                  <span class="tooltip-block">
                    {{ "products.as-of-capitalize" | translate }}&nbsp;{{ data?.performanceData?.asOfDate }}
                  </span>
                </span>
                <span
                    class="text-small mt-0">{{ data?.selectedDropdown?.assetValue ? data?.selectedDropdown?.assetValue + '%' : 'NA' }}</span>
              </div>
              <div *ngIf="data?.selectedDropdown?.assetValue else perfElse">
                <div class="dropdown Inception-dropdown d-md-none d-inline-block">
                  <button style="font-size:13px!important;" class="btn btn-white dropdown-toggle"
                          type="button" data-bs-toggle="dropdown" id="dropdownMenuButton2">
                    {{ data?.selectedDropdown?.label }}
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li *ngFor="let dropdown of data?.performancePeriodDropdownItems"
                        [class.disabled]="dropdown?.disabled">
                      <a class="dropdown-item" [class]="dropdown?.disabled?'disabled':'cur-pointer'"
                         (click)="updateSelectedDropdown(dropdown,data.fundId)">{{ dropdown?.label }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <ng-template #perfElse>
                <span class="text-big">NA</span>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
    <ng-template #elseBlock>
      <div>Loading ...</div>
    </ng-template>
  </div>
</div>
